// SVG Map Controller

( function( $, window, document, undefined ) {
	
	let SVGMapContoller = class SVGMapContoller {

		constructor( $element ) {
			let _ = this;

			_.$element = $element;

			_.$draggableContainer = _.$element.parent();
			_.$container = _.$draggableContainer.parent();

			// Only buildings with an id attribute will have an associated section
			// Since there could be IDs for tenants/lettings areas, filter 
			// to only IDs that have a corresponding details element
			_.$buildings = _.$element.find( '[id]' ).filter( (index, building) => {
				let $tenant = _._getTenant( $(building).attr('id') );

				return !!$tenant;
			} );

			_.$zoomControls = $('.js-svgmap-zoom');
			_.$toggleControls = $('.js-svgmap-toggle');

			// Initial scale as well as being used to maintain current state
			_._scale = 1;
			_._minScale = 0.4;
			_._maxScale = 2;

			_._isBeingDragged = false;

			_._isZooming = false;
			_._zoomInterval = 150;
			_._zoomTimer = null;

			_._bindEvents();
		}

		_getTenant( id ) {
			let _ = this,
					$tenant = $( `[data-tenant="${id}"]` );

			if ( !$tenant.length ) {
				return false;
			}

			return $tenant;
		}

		_bindEvents() {
			let _ = this;

			// Make the map container draggable for navigation
			_.$draggableContainer.draggable( {
				scroll: false,
				start: () => {
					_._isBeingDragged = true;
				},
				stop: () => {
					_._isBeingDragged = false;
				},
			} );

			/**
			 * Link up zoom controls so that they keep zooming 
			 * if the button is held down.
			 * Starts a timer and then zooms in specific increments.
			 */
			_.$zoomControls.mousedown( (event) => {
				if ( 1 == event.which ) {
					let $target = $( event.target ),
							amount;

					if ( !$target.is( '.js-svgmap-zoom' ) ) {
						$target = $target.closest( '.js-svgmap-zoom' );
					}

					amount = $target.attr( 'data-scale' );
					_._isZooming = true;

					// Run first call straight away, function recurs
					_.zoom( amount );

					event.preventDefault();
					return false;
				}
			} );

			/**
			 * Listen for mouseup events to cancel the timer.
			 * Listened for events across the document, to prevent
			 * the situation where somebody clicks on the button,
			 * moves the mouse off, and then releases the button 
			 * on a separate element.
			 */
			$(document).mouseup( (event) => {
				_._isZooming = false;

				if ( null !== _._zoomTimer ) {
					clearTimeout( _._zoomTimer );
					_._zoomTimer = null;
				}
			} );

			_.$toggleControls.click( (event) => {
				if ( 1 == event.which ) {
					let $event = $(event.target);

					if ( !$event.is( '.js-svgmap-toggle' ) ) {
						$event = $event.closest( '.js-svgmap-toggle' );
					}

					let $map = $( $event.data('map') );

					if ( $map.length ) {
						$map.siblings().hide();
						$map.show();

						_.$toggleControls.removeClass('is-active');
						$event.addClass('is-active');
					}

					event.preventDefault();
					return false;
				}
			} );

			// On click, show tenants details pane
			_.$buildings.click( (event) => {
				let $target = $( event.target );

				_.showDetails( $target );
			} );

			return _;
		}

		_clearInterval() {
			let _ = this;

			if ( null !== _._zoomIntervalID ) {
				clearInterval( _._zoomIntervalID );
			}

			return _;
		}

		roundDecimal(value, precision) {
	    var multiplier = Math.pow(10, precision || 0);
	    return Math.round(value * multiplier) / multiplier;
		}

		zoom( amount ) {
			let _ = this,
					newScale,
					transform;

			if ( _._isZooming ) {
				newScale = _.roundDecimal( _._scale + parseFloat( amount ), 1);

				// Constrain to min and max
				newScale = Math.min( newScale, _._maxScale );
				newScale = Math.max( newScale, _._minScale );

				_._scale = newScale;
				transform = _._getTransform();

				_.$element.css( { 
					transform: transform
				} );

				setTimeout( () => _.zoom( amount ), _._zoomInterval );
			}

			return _;
		}

		_getTransform() {
			let _ = this,
					scaleTransform = `scale( ${_._scale} )`;

			// Return another template literal to allow
			// compound transforms to be built in future
			return `${scaleTransform}`;
		}

		showDetails( $building ) {
			let _ = this,
					$target = _._getTenant( $building.attr('id') );

			if ( $target.length ) {
				$('[data-tenant]').hide();
				$target.show();

				if ( windowWidth() <= 1023 ) {
					window.location = $target.find('.button').get(0).href;
				}

				_.$buildings.css( 'fill', '' );

				$building.css( 'fill', 'red' );
			}
		}

	};


	// Expose API
	window.SVGMapContoller = SVGMapContoller;

} )( jQuery, window, document );
